if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/serviceworker.js?v=2').then(function (registration) {
        // console.log('ServiceWorker registration successful');
    }, function (err) {
        // console.log('ServiceWorker registration failed');
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/sw.js